import React from "react";

import styles from "../CSS/splash_screen.module.css";

const splashScreen = () => (
	<div className={styles.div}>
		<div>S</div>
		<h2>Shirtsy</h2>
	</div>
);

export default splashScreen;
